import React from "react";
import ReactDOM from "react-dom";
import "./normalize.css";
import "./index.css";

(import("./DoctorApp")).then(component => {
    const App = component.default
    ReactDOM.render(<App />, document.getElementById("root"));
}).catch(() => {
    ReactDOM.render(<div>Something went wrong</div>, document.getElementById("root"));
})
